import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import AppButton from "@/features/line-sheet-sets/app-button";
import CustomIcon from "../../../../../../../public/icons-v1_1";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import PathPickBasketActionCollapsibleRow from "@/features/pathpick/features/basket/components/action-panel/PathPickBasketActionCollapsibleRow";
import usePathPickBasketSelection from "@/features/pathpick/features/basket/hooks/usePathPickBasketSelection";
import usePathPickBasketBulkOrder from "@/features/pathpick/features/basket/hooks/usePathPickBasketBulkOrder";
import PathPickBasketOrderLimitTooltip from "@/features/pathpick/features/basket/components/order/PathPickBasketOrderLimitTooltip";
import PathPickOrderQuantityModal from "@/features/pathpick/components/order/PathPickOrderQuantityModal";

// 상품 주문 행 + 주문 수량 모달 소유
function PathPickBasketProductOrderPanel() {
  const { t } = useI18nHelper();
  const { startBulkOrder, isLoading, isOverLimit } =
    usePathPickBasketBulkOrder();
  const {
    selectedCount,
    soldOutCount,
    removeProducts,
    orderModalItems,
    closeOrderModal,
  } = usePathPickBasketSelection();

  const hasSelection = selectedCount > 0;
  // 품절 상품이 섞여 있거나 일괄 주문 한도를 넘으면 선택을 고치기 전까지 주문을 막는다.
  const isOrderDisabled = !hasSelection || soldOutCount > 0 || isOverLimit;

  return (
    <>
      <PathPickBasketActionCollapsibleRow
        icon={"cart"}
        title={t("path_pick:basket.action_panel.order_title")}
        description={
          <Text textStyle={"body-sm-medium"} color={"#8F8F8C"}>
            {t("path_pick:basket.action_panel.order_description")}
          </Text>
        }
        // 반응형 폭은 툴팁 래퍼가 맡고 버튼은 래퍼를 채운다.
        actions={
          <PathPickBasketOrderLimitTooltip
            isActive={isOverLimit}
            wrapperProps={{
              flexShrink: 0,
              width: { base: "100%", md: "184px" },
            }}
          >
            <AppButton
              variant={"primary"}
              height={"36px"}
              isDisabled={isOrderDisabled}
              isLoading={isLoading}
              onClick={startBulkOrder}
              // AppButton의 width는 문자열 전용이라 폭은 sx로 준다.
              chakraProps={{ sx: { width: "100%" } }}
            >
              <Flex gap={"4px"} alignItems={"center"} justifyContent={"center"}>
                <CustomIcon
                  src={"cart"}
                  width={16}
                  height={16}
                  color={isOrderDisabled ? "#8F8F8C" : "#FFFFFF"}
                />
                <Text textStyle={"body-sm-bold"}>
                  {t("path_pick:basket.action_panel.order_button")}
                </Text>
              </Flex>
            </AppButton>
          </PathPickBasketOrderLimitTooltip>
        }
      />

      {orderModalItems && (
        <PathPickOrderQuantityModal
          isOpen
          onClose={closeOrderModal}
          items={orderModalItems}
          // 주문된 상품만 선택에서 뺀다 — 카드별 주문은 선택과 무관한 1건이라
          // 여기서 전체를 비우면 관계없는 선택까지 날아간다.
          onOrderCompleted={removeProducts}
        />
      )}
    </>
  );
}

export default PathPickBasketProductOrderPanel;
